import { useTranslation } from 'react-i18next';
import { FaArrowLeft } from 'react-icons/fa';
import { FcReadingEbook } from 'react-icons/fc';
import { useNavigate } from 'react-router';
import { FiMenu } from 'react-icons/fi';

import {
  Flex,
  HStack,
  IconButton,
  Menu,
  MenuButton,
  MenuDivider,
  MenuItem,
  MenuList,
  Text,
  useDisclosure,
} from '@chakra-ui/react';

import { useAuth } from '../../../context/useAuth';
import LogoutConfirmationDialog from '@/components/Modals/LogoutConfirmationDialog';
import { useTrimmedFullName } from '@/utils/useTrimmedFullName';

interface HeaderProps {
  backPath?: string;
  onOpen?: () => void;
}

const Header = ({ backPath, onOpen, ...rest }: HeaderProps) => {
  const { logout, fullName } = useAuth();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const trimmedFullName = useTrimmedFullName(fullName);
  const {
    isOpen: isLogoutDialogOpen,
    onOpen: onLogoutDialogOpen,
    onClose: onLogoutDialogClose,
  } = useDisclosure();

  const handleBack = () => {
    if (backPath) {
      navigate(backPath);
    }
  };

  const handleProfile = () => {
    navigate('/profile');
  };

  return (
    <Flex
      px={{ base: 4, md: 4 }}
      height={{ base: '16', md: '20' }}
      alignItems="center"
      justifyContent="space-between"
      bg="orange.50"
      borderBottom="1px solid"
      borderBottomColor="gray.100"
      boxShadow="sm"
      {...rest}
    >
      <HStack spacing={4}>
        {backPath && (
          <IconButton
            size="lg"
            variant="ghost"
            aria-label="Go back"
            icon={<FaArrowLeft size={40} />}
            _hover={{ opacity: 0.7 }}
            onClick={handleBack}
          />
        )}
        {onOpen && (
          <IconButton
            display={{ base: 'flex', md: 'none' }}
            onClick={onOpen}
            variant="outline"
            color="orange.400"
            borderColor="orange.400"
            aria-label="open menu"
            icon={<FiMenu size={30} />}
            size="lg"
          />
        )}
      </HStack>

      <HStack spacing={{ base: '0', md: '2' }}>
        <Text
          fontSize={{ base: 'sm', md: 'lg', lg: 'xl' }}
          fontWeight={'semibold'}
          display={{ base: 'none', md: 'block' }}
          title={`${t('welcome')} ${fullName} さん`}
        >
          {`${t('welcome')} ${trimmedFullName} さん`}
        </Text>
        <Flex alignItems={'center'} display={{ base: 'none', md: 'flex' }}>
          <Menu>
            <MenuButton
              transition="all 0.3s"
              _focus={{ boxShadow: 'none' }}
              _hover={{ opacity: 0.7 }}
            >
              <HStack>
                <FcReadingEbook size={40} />
                {/* <FaUserCircle size={40} /> */}
              </HStack>
            </MenuButton>
            <MenuList bg="white" borderColor="gray.200">
              <MenuItem
                _focus={{ boxShadow: 'none' }}
                _hover={{
                  bg: 'teal',
                  color: 'white',
                }}
                onClick={handleProfile}
              >
                {t('profile-button')}
              </MenuItem>
              {/* <MenuItem
                _hover={{
                  bg: 'teal',
                  color: 'white',
                }}
              >
                Settings
              </MenuItem> */}
              <MenuDivider />
              <MenuItem
                _focus={{ boxShadow: 'none' }}
                _hover={{
                  bg: 'teal',
                  color: 'white',
                }}
                onClick={onLogoutDialogOpen}
              >
                {t('logout-button')}
              </MenuItem>
            </MenuList>
          </Menu>
        </Flex>
      </HStack>
      <LogoutConfirmationDialog
        isOpen={isLogoutDialogOpen}
        onClose={onLogoutDialogClose}
        onConfirm={() => {
          onLogoutDialogClose();
          logout();
        }}
      />
    </Flex>
  );
};

export default Header;
